import VForm from '@/vuetify_custom/v-form'
import {formattingNumber} from '@/libs/util';
import { VCard, VCardTitle, VCardText, VTabs, VTab, VBtn, VIcon } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import { common_mixins } from './EditMixIns.jsx'
import mmxins from '@/views/fin/components/mixIns.jsx'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import styles from './index.module.less'
import {placing_ads_record_select_search, placing_ads_vas_record_select_search} from './service'
import VPopSelect from '@/vuetify_custom/v-pop-select.vue'
import VPage from '@/vuetify_custom/v-pagination'
import Tooltip from '@/views/mine/components/fk_modal/Tooltip.vue'

export const getPlacingAdsRecordsSumMixins = {
    methods: {
        getPlacingAdsRecordsSum(target) {
            const params = target || this.params
            
            const arr = params && params.placing_ads_records || []
            const arr_1 = params && params.placing_ads_vas_records || []
            if (arr.length === 0 && arr_1.length === 0) {
                return 0
            }
            let sum = math.eval('0')
            arr.forEach(i => {
                sum = math.eval(`${i.have_paid_amount || 0}+${sum || 0}`)
            })
            arr_1.forEach(i => {
                sum = math.eval(`${i.have_paid_amount || 0}+${sum || 0}`)
            })
         
            return sum.toNumber() 
        }
    }
}

export default {
    mixins:[common_mixins, mmxins, getPlacingAdsRecordsSumMixins],
    props: {
        havePaidAmountitle: {
            type:String
        },
        havePaidAmountitleTotal: {
            type:String
        },
        showCalculate: {
            type: Boolean
        },
        refresh: {
            type: Boolean
        }
    },
    data() {
        return {
            is_expand: true,
            render_index: 0,
            tf_page: 1,
            tf_page_size: 10,
            jc_page: 1,
            jc_page_size: 10
        }
    },
    computed: {
        fields_proxy() {
            const tab = Number(this.params.tfjc_type)
            let arr = null
            if (tab === 0) { // 
                const common_placingadsrecord_fields = [...this.common_placingadsrecord_fields]
                let pre = []
                const common_placingadsrecord_fields_pre = []
                common_placingadsrecord_fields.forEach(i => {
                    if (i.text === '预计投放金额') {
                        pre = [i]
                    } else {
                        common_placingadsrecord_fields_pre.push(i)
                    }
                })
                common_placingadsrecord_fields_pre.splice(1, 0, ...pre)
               
                arr = common_placingadsrecord_fields_pre.map(i => {
                    if (i.value === 'xiaoguo') {
                        // Effect
                        return {
                            ...i,
                            render:(_, t) => {
                                return <div>
                                  <Tooltip value={t} showList={[ 2, 3]}/>
                            </div>
                            } 
                        }
                    }
                    return i
                })
            } else {
                const common_placing_ads_vas_record_fields = [...this.common_placing_ads_vas_record_fields]
                let pre = []
                const common_placing_ads_vas_record_fields_pre = []
                common_placing_ads_vas_record_fields.forEach(i => {
                    if (i.text === '服务金额') {
                        pre = [i]
                    } else {
                        common_placing_ads_vas_record_fields_pre.push(i)
                    }
                })
                common_placing_ads_vas_record_fields_pre.splice(1, 0, ...pre)
                arr = common_placing_ads_vas_record_fields_pre
               
            }
            arr = [ {
                text: '操作',
                align: 'center',
                value: 'handle',
                width: 120,
                fixed: 'left',
                render:(_, t) => {
                  return <VBtn color="error" text small on={{
                    click: () => {
                        if (Number(this.params.tfjc_type) === 0) {
                            const new_arr = []
                            this.params.placing_ads_records.forEach(i => {
                                if (i !== t) {
                                    new_arr.push(i)
                                }
                            })
                            this.params.placing_ads_records = new_arr
                        } else {
                            const new_arr = []
                            this.params.placing_ads_vas_records.forEach(i => {
                                if (i !== t) {
                                    new_arr.push(i)
                                }
                            })
                            this.params.placing_ads_vas_records = new_arr
                        }
                    }
                  }}>
                    删除
                  </VBtn>
                }
              }, ...arr.slice(0, 1), {
                text: this.havePaidAmountitle,
                align: 'right',
                width: 140,
                value: 'have_paid_amount',
                render:(_, t) => {
                  return <NumberField
                  field={{
                    label: '',
                    key: 'have_paid_amount',
                    d_digits:2,
                    placeholder: '请输入',
                    suffix: '元',
                    blur:() => {
                        this.render_index++
                    },
                    rules: [val => {
                        if (['', undefined, null].includes(val)) {
                            return '必填'
                        }
                        return true
                    },
                   
                     val => {
                        if (val < 0&&tab===0) {
                            return '需要填写大于等于0的金额'
                        }
                        return true
                    }]          
                  }}
                  v-model={t}
              />
                }
       
            }, ...arr.slice(1)]
            return arr
        },
        total_proxy() {
            const tab = Number(this.params.tfjc_type)
            let arr = []
            if (tab === 0) { // 
                arr = this.params.placing_ads_records
            } else {
                arr = this.params.placing_ads_vas_records
            }
            return arr.length
        },
        datasource() {
            const tab = Number(this.params.tfjc_type)
            let arr = []
            if (tab === 0) { // 
                arr = this.params.placing_ads_records
            } else {
                arr = this.params.placing_ads_vas_records
            }
           return arr.slice((this.current_page - 1) * this.page_size_proxy, this.current_page * this.page_size_proxy)
        },
        placing_ads_records_sum() {
            this.render_index
        
            return this.getPlacingAdsRecordsSum()
        },
        show_add() {
            if (this.params.payment_purpose === 'outsource') { // 
                return !!this.params.outsource_contract_id
            }
            return !!this.params.contract_id
        },
        current_page: {
            get() {
                const tab = Number(this.params.tfjc_type)
                return tab === 0 ? this.tf_page : this.jc_page
            },
            set(v) {
                const tab = Number(this.params.tfjc_type)
                if (tab === 0) {
                    this.tf_page = v
                } else {
                    this.jc_page = v
                }
               
            }
        },
        page_size_proxy: {
            get() {
                const tab = Number(this.tf_page_size)
                return tab === 0 ? this.tf_page_size : this.jc_page_size
            },
            set(v) {
                const tab = Number(this.tf_page_size)
                if (tab === 0) {
                    this.tf_page_size = v
                } else {
                    this.jc_page_size = v
                }
               
            }
        }
    },
    watch: {
        'params.placing_ads_records'() {
            this.render_index++
        },
        'params.placing_ads_vas_records'() {
            this.render_index++
        },
        placing_ads_records_sum: {
            handler(val) {
                this.params.placing_ads_records_sum = val
            },
            immediate: true
        },
        refresh(v) {
            if (!v) {
                this.tf_page = 1
                this.tf_page_size = 10
                this.jc_page = 1
                this.jc_page_size = 10
            }
        }
    },
    methods: {
       
        calculate() {
            let {expense_group_settlements = [], placing_ads_records} = this.params || {}
            placing_ads_records = placing_ads_records || []
            expense_group_settlements = expense_group_settlements || []
            const arr = expense_group_settlements.filter(i => Number(i.payment_amount))
            const target = arr[0]
            if (arr.length !== 1 || !placing_ads_records.length) {
                this.$Message.warning('当前不能自动计算！')
                return 
            }
            const {settlement_percentage} = target || {}
            this.params.placing_ads_records.forEach(i => {
                i.have_paid_amount = math.eval(`${i.total_price || 0}*${settlement_percentage || 0}/100`).toNumber()
            })
            this.render_index++
          //   console.log('target', this.params.placing_ads_records)
           
        }
    },
    render() {
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                投放记录/加成服务 {this.show_add && <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    disabled={this.params.placing_ads_records && this.params.placing_ads_records.length >= 30}
                    // this.params.placing_ads_records
                    on={{
                        click:() => {
                            const tab = Number(this.params.tfjc_type)
                            switch (tab) {
                                case 0:
                                    if (!this.params.placing_ads_records) {
                                        this.$set(this.params, 'placing_ads_records', [])
                                    }
                                    this.params.placing_ads_records.push({})
                                    break;
                                case 1:
                                    if (!this.params.placing_ads_vas_records) {
                                        this.$set(this.params, 'placing_ads_vas_records', [])
                                    }
                                    this.params.placing_ads_vas_records.push({})
                                    break;
                                default:
                                    break;
                            }
                        }
                    }}
                    >
                    添加条目
                </VBtn>}
                {
                    !!this.showCalculate && <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                  
                    on={{
                        click:() => this.calculate()
                    }}
                    >
                    自动计算
                </VBtn>
                }
                {this.params.placing_ads_records && this.params.placing_ads_records.length >= 35 && <span>最多关联35个投放记录</span>}
                <VIcon color="primary" style="cursor: pointer;margin-left:20px" on={{click:() => {
                        this.is_expand = !this.is_expand
                }}}>{this.is_expand ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }</VIcon>
              
            </VCardTitle>
            <VCardText style={{display: this.is_expand ? 'block' : 'none'}}>
            <div style="margin:10px 0">{this.havePaidAmountitleTotal}{
            formattingNumber(this.placing_ads_records_sum, 2) }</div>
            <VTabs
                
                v-model={this.params.tfjc_type}>
                   <VTab>
                      投放记录
                   </VTab>
                   <VTab>
                      加成服务
                   </VTab>
               </VTabs>
              
                <VForm
                    ref="base"
                    fields={[{key: 'table'}]}
                    scopedSlots={{
                        table:() => <div>
                            <VTable 
                                headers={this.fields_proxy}
                                desserts={this.datasource}
                                scopedSlots={{
                                    uid:(value, target) => { 
                                        const tab = Number(this.params.tfjc_type)
                                        const url = tab === 0 ? placing_ads_record_select_search : placing_ads_vas_record_select_search
                                        const outParams = tab === 0 ? this.tf_records_out_params : this.jc_records_out_params
                                        return <VPopSelect
                                        text = ''
                                        placeholder=''
                                        outParams={outParams}
                                        url={url}
                                        handleSearch={(d) => {
                                            const tab = Number(this.params.tfjc_type)
                                            let arr = tab === 0 ? this.params.placing_ads_records : this.params.placing_ads_vas_records
                                            arr = arr || []
                                            arr = arr.map(i => i.id)
                                            return d.filter(i => !arr.includes(i.id))
                                        }}
                                        contentHeigh={400}
                                        on={{
                                            change:(item) => {
                                            const tab = Number(this.params.tfjc_type)
                                            const arr = tab === 0 ? this.params.placing_ads_records : this.params.placing_ads_vas_records
                                                arr.forEach((detail, index) => {
                                                    if (detail === target) {
                                                        this.$set(arr, index, item)
                                                    }
                                                });
                                            }
                                        }}
                                        render = {
                                            (h, item) => {
                                                return <div>
                                                    <p class={styles['p-c']}>
                                                        {item.uid}
                                                    </p>
                                                </div>
                                            }
                                        }
                                        valueRender={() => {
                                            return target && target.uid || ''
                                        }}
                                    />
                                    }
                                }}
                            />
                           {!!this.total_proxy && <VPage
                                current={this.current_page}
                                total={this.total_proxy }
                                page-size={this.page_size_proxy}
                                size-arr={[10, 20, 50]}
                                on={
                                {
                                    changePageSize:(per_page) => {
                                       
                                        this.page_size_proxy = per_page
                                    },
                                    pageChange:(page) => {
                                     
                                        this.current_page = page
                                    }
                                }
                                }
                            />}
                        </div> 
                    }}
                />
            </VCardText>
        </VCard>
    </div>
    }
}

